import React from 'react';
import { Provider } from 'react-redux';
import store from './store';
import QueryBuilder from './views/QueryBuilder/QueryBuilder';

const App = () => /*#__PURE__*/React.createElement(Provider, {
  store: store
}, /*#__PURE__*/React.createElement(QueryBuilder, null));

export default App;